import { render, staticRenderFns } from "./BasketItem.vue?vue&type=template&id=0a4d1b28&scoped=true"
import script from "./BasketItem.vue?vue&type=script&lang=js"
export * from "./BasketItem.vue?vue&type=script&lang=js"
import style0 from "./BasketItem.vue?vue&type=style&index=0&id=0a4d1b28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4d1b28",
  null
  
)

export default component.exports